import React, { createContext, useContext, useMemo } from 'react';

const AccordionItemContext = createContext(null);
function useAccordionItem() {
    const context = useContext(AccordionItemContext);
    if (!context) {
        throw new Error('useAccordionItem must be used within AccordionItem');
    }
    return context;
}
function AccordionItem({ children, value, }) {
    const contextValue = useMemo(() => ({
        value,
    }), []);
    return (React.createElement(AccordionItemContext.Provider, { value: contextValue }, children));
}

export { AccordionItem, useAccordionItem };
